<div class="modal-header justify-content-between">
    <h4 class="modal-title header-13">
      {{ title }}
    </h4>
    <div>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
    </div>
  </div>
  
  <div class="assets-detail">
    <app-dynamic-form [form]="dynamicForm" [formFields]="fields"></app-dynamic-form>
  </div>

  <div class="modal-footer border-0">
    <div class="d-flex justify-content-end">
      <button
        class="btn-accello-secondary mx-2 open-btn"
        (click)="activeModal.dismiss('Cross click')"
      >
        {{ buttonText.secondary }}
      </button>
      <button
        class="btn-accello-primary-light open-btn"
        (click)="close()"
      >
        {{ buttonText.primary }}
      </button>
    </div>
  </div>
  